const variantName = 'heroV3'

export default {
  [variantName]: {
    // ?============================
    // ?======  Containers =========
    // ?============================

    container: {
      height: '100vh',
      width: '100%',
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      justifyContent: 'center',
      alignItems: 'center',
    },

    // ?============================
    // ?======  Box Content ========
    // ?============================

    content: {
      padding: '2rem',
      flexDirection: 'column',
      color: 'white',
      textAlign: 'center',
      h1: {
        fontSize: '2rem',
        marginTop: '0px',
        marginBottom: 1,
      },
      h2: {
        fontSize: '1rem',
        marginTop: '0px',
        marginBottom: 4,
      },
      logo: {
        marginBottom: 4,
      },
      button: {
        variant: 'buttons.multiLocation',
      },
    },
  },
}
